module.exports = __webpack_public_path__ + "img/enfardadora-02.33455365.jpg";